import axios from "common/helpers/axios.helper"

const reportError = (error) => {

    if (error.response) {
        if (error.response.status === 400) {
            console.log('ERROR(response): status: 400 -> Session ist abgelaufen', error.response)
        } else {
            console.log('ERROR(response): Aktion konnte nicht ausgeführt werden!')
        }

    } else if (error.request) {
        console.log('ERROR(request)', error.request)
    } else {
        console.log('ERROR(request) setup?', error.message)
    }
}

export const createDir = (path, successCallback = null, errorCallback = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'DIR_CREATE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/dir/${currentContainer}/${path}`),
            method: 'POST',
            timeout: 10 * 1000,
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
        }).then((response) => {
            dispatch({ type: 'DIR_CREATE_SUCCESS', payload: response.data });
            successCallback && successCallback(response.data);
        }).catch((error) => {
            reportError(error)
            errorCallback && errorCallback(error);
            dispatch({ type: 'DIR_CREATE_ERROR', payload: error.response })
        });
    }
}

export const renameDir = (path, newName, successCallback = null, errorCallback = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'DIR_RENAME_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/dir/${currentContainer}/${path}`),
            method: 'PATCH',
            data: { new: newName },
            timeout: 10 * 1000,
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
        }).then((response) => {
            dispatch({ type: 'DIR_RENAME_SUCCESS', payload: response.data });
            successCallback && successCallback(response.data);
        }).catch((error) => {
            reportError(error)
            errorCallback && errorCallback(error)
            dispatch({ type: 'DIR_RENAME_ERROR', payload: error.response })
        });
    }
}

export const deleteDir = (path, successCallback = null, errorCallback = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'DIR_DELETE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/dir/${currentContainer}/${path}`),
            method: 'DELETE',
            timeout: 10 * 1000,
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'DIR_DELETE_SUCCESS', payload: response.data });
            successCallback && successCallback(response.data)
        }).catch((error) => {
            reportError(error)
            errorCallback && errorCallback(error)
            dispatch({ type: 'DIR_DELETE_ERROR', payload: error.response })
        });
    }
}